package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.rows
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.setDoc
import org.lennycodes.hldi.data.Milestone


@Composable
fun AddMilestoneDialog(
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()

    var isLoading by remember { mutableStateOf(false) }

    var year by remember { mutableStateOf("") }
    var description by remember { mutableStateOf("") }

    var errorMessage by remember { mutableStateOf("") }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!isLoading) {
                        onDismiss()
                    }
                }
            }
    ) {


        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }
                }
        ) {


            H3(
                attrs = DialogTitleStyle.toAttrs()
            ) {
                Text("New Milestone")
            }


            // Year Field
            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Year")
                }


                Input(
                    type = InputType.Number,
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder("2026")

                            value(year)

                            onInput {

                                val input = it.value

                                if (input.toString().length <= 4) {
                                    year = input.toString()
                                }

                            }

                            if (isLoading) {
                                disabled()
                            }
                        }
                )
            }



            // Description Field
            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Description")
                }


                TextArea(
                    value = description,
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {
                            rows(4)
                            placeholder(
                                "Describe the achievement"
                            )

                            onInput {
                                description = it.value
                            }

                            if (isLoading) {
                                disabled()
                            }
                        }
                )

            }



            if (errorMessage.isNotEmpty()) {

                P(
                    attrs = Modifier
                        .color(Color.rgb(220, 53, 69))
                        .fontSize(14.px)
                        .margin(0.px, 0.px, 16.px)
                        .toAttrs()
                ) {

                    Text(errorMessage)

                }
            }



            Row(
                modifier = DialogActionsRowStyle.toModifier(),
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {


                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px, 22.px)
                        .then(CancelButtonStyle.toModifier()),

                    onClick = { onDismiss() }

                ) {

                    Text("Cancel")

                }



                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px, 22.px)
                        .then(SaveButtonStyle.toModifier()),

                    onClick = {

                        scope.launch {

                            errorMessage = ""

                            if (year.isBlank()) {
                                errorMessage = "Milestone year is required"
                                return@launch
                            }


                            if (!isValidYear(year)) {
                                errorMessage = "Please enter a valid year from 2015"
                                return@launch
                            }


                            if (description.isBlank()) {
                                errorMessage = "Milestone description is required"
                                return@launch
                            }


                            try {

                                isLoading = true


                                val milestoneCollection =
                                    collection(
                                        FirebaseService.db,
                                        "milestones"
                                    )


                                val generatedId =
                                    generateFirebaseId()


                                val milestoneDocument =
                                    doc(
                                        milestoneCollection,
                                        generatedId
                                    )


                                val milestone =
                                    Milestone(
                                        id = generatedId,
                                        year = year,
                                        description = description
                                    )


                                setDoc(
                                    milestoneDocument,
                                    milestone.toFirebaseData()
                                ).await()


                                console.log(
                                    "Milestone saved successfully"
                                )


                                onSuccess()
                                onDismiss()


                            } catch (e: Throwable) {


                                console.error(
                                    "Saving milestone failed: ${e.message}"
                                )


                                errorMessage =
                                    e.message
                                        ?: "Something went wrong"


                            } finally {

                                isLoading = false

                            }

                        }

                    }

                ) {

                    Text(
                        if (isLoading)
                            "Saving..."
                        else
                            "Save"
                    )

                }

            }

        }

    }

}